import React, { useEffect, useState } from "react";
import { adminGetContacts, adminGetNewsletter, adminGetStockRequests } from "@/lib/adminApi";

export default function AdminMessages() {
  const [tab, setTab] = useState("contacts");
  const [contacts, setContacts] = useState([]);
  const [subs, setSubs] = useState([]);
  const [stockReqs, setStockReqs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([adminGetContacts(), adminGetNewsletter(), adminGetStockRequests()])
      .then(([c, n, s]) => { setContacts(c); setSubs(n); setStockReqs(s); })
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="admin-messages">
      <h1 className="admin-title" style={{ marginBottom: "1.5rem" }}>Messages</h1>
      <div className="adm-tabs">
        <button className={`adm-tab ${tab === "contacts" ? "active" : ""}`} onClick={() => setTab("contacts")} data-testid="tab-contacts">Contact ({contacts.length})</button>
        <button className={`adm-tab ${tab === "newsletter" ? "active" : ""}`} onClick={() => setTab("newsletter")} data-testid="tab-newsletter">Newsletter ({subs.length})</button>
        <button className={`adm-tab ${tab === "stock" ? "active" : ""}`} onClick={() => setTab("stock")} data-testid="tab-stock-requests">Réassort ({stockReqs.length})</button>
      </div>

      {loading ? <div className="adm-loader"><div className="spinner" /></div> : tab === "contacts" ? (
        <table className="admin-table" data-testid="contacts-table">
          <thead><tr><th>Date</th><th>Nom</th><th>Email</th><th>Sujet</th><th>Message</th></tr></thead>
          <tbody>
            {contacts.length === 0 ? <tr><td colSpan="5" className="adm-hint" style={{ padding: "2rem", textAlign: "center" }}>Aucun message.</td></tr> : null}
            {contacts.map((c) => (
              <tr key={c.id}>
                <td style={{ whiteSpace: "nowrap" }}>{c.created_at ? new Date(c.created_at).toLocaleDateString("fr-FR") : ""}</td>
                <td>{c.name}</td><td>{c.email}</td><td>{c.subject}</td>
                <td style={{ maxWidth: 320, whiteSpace: "normal" }}>{c.message}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : tab === "newsletter" ? (
        <table className="admin-table" data-testid="newsletter-table">
          <thead><tr><th>Date</th><th>Email</th></tr></thead>
          <tbody>
            {subs.length === 0 ? <tr><td colSpan="2" className="adm-hint" style={{ padding: "2rem", textAlign: "center" }}>Aucun inscrit.</td></tr> : null}
            {subs.map((s) => (
              <tr key={s.id}><td style={{ whiteSpace: "nowrap" }}>{s.created_at ? new Date(s.created_at).toLocaleDateString("fr-FR") : ""}</td><td>{s.email}</td></tr>
            ))}
          </tbody>
        </table>
      ) : (
        <table className="admin-table" data-testid="stock-requests-table">
          <thead><tr><th>Date</th><th>Email</th><th>Produit</th></tr></thead>
          <tbody>
            {stockReqs.length === 0 ? <tr><td colSpan="3" className="adm-hint" style={{ padding: "2rem", textAlign: "center" }}>Aucune demande de réassort.</td></tr> : null}
            {stockReqs.map((s) => (
              <tr key={s.id}>
                <td style={{ whiteSpace: "nowrap" }}>{s.created_at ? new Date(s.created_at).toLocaleDateString("fr-FR") : ""}</td>
                <td>{s.email}</td>
                <td>{s.product_name || s.product_id}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
